export const newSlide = [
    {
        id: "q_72-u76Ig",
        elements: [
            {
                type: "slidelayout",
                id: "BM-JnudV4F",
                left: 0,
                top: 0,
                width: 1366,
                height: 768,
                content: "",
                rotate: 0,
                defaultFontName: "Arial",
                defaultColor: "#333",
                layout: {
                    type: "layout",
                    children: [
                        {
                            type: "row",
                            children: [
                                {
                                    id: "iJ7MYSI7SP",
                                    style: {
                                        valign: "center",
                                        align: "center",
                                        justifyContent: "center",
                                        containerHeight: 115
                                    },
                                    dragDropElement: {
                                        type: "dragdrop",
                                        id: "iJ7MYSI7SP",
                                        left: 0,
                                        top: 0,
                                        width: 1366,
                                        height: 768,
                                        content: "",
                                        rotate: 0,
                                        defaultFontName: "Arial",
                                        defaultColor: "",
                                        layout: [
                                            {
                                                type: "row",
                                                id: "ut_vld8yAk",
                                                children: [
                                                    {
                                                        id: "iB6mgCX-En",
                                                        style: {
                                                            valign: "center",
                                                            align: "left",
                                                            justifyContent: "",
                                                            margin: 5
                                                        },
                                                        alternateColor: null,
                                                        type: "subsection"
                                                    }
                                                ],
                                                style: {
                                                    backgroundColor: "transparent",
                                                    clipTop: 10,
                                                    clipRight: 10,
                                                    clipBottom: 10,
                                                    clipLeft: 10,
                                                    borderRadius: 10,
                                                    valign: "center",
                                                    align: "center",
                                                    justifyContent: "center"
                                                }
                                            }
                                        ],
                                        widgets: [
                                            {
                                                parent: "iJ7MYSI7SP-iB6mgCX-En",
                                                children: [
                                                    {
                                                        id: "BFaG2gkM1X",
                                                        type: "reg_text",
                                                        subType: "out_text",
                                                        hookId: "",
                                                        compact: false,
                                                        iconPosition: "none",
                                                        text: "<p style=\"\"><strong><span style=\"font-size: 30px\">Title</span></strong></p>",
                                                        step: 1,
                                                        currency: "USD",
                                                        locale: "en-US",
                                                        csv: {},
                                                        style: {
                                                            borderRadius: 0,
                                                            fontSize: "20px",
                                                            padding: 25
                                                        },
                                                        chartType: "",
                                                        imageUrl: "",
                                                        min: 0,
                                                        max: 100,
                                                        alternateColor: null
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    alternateColor: null,
                                    type: "section"
                                }
                            ],
                            id: "GH9TLNuAwH"
                        },
                        {
                            type: "row",
                            children: [
                                {
                                    id: "XOZ40vxcR2",
                                    style: {
                                        valign: "center",
                                        align: "center",
                                        justifyContent: "center"
                                    },
                                    alternateColor: null,
                                    type: "section",
                                    dragDropElement: {
                                        type: "dragdrop",
                                        id: "XOZ40vxcR2",
                                        left: 0,
                                        top: 0,
                                        width: 1366,
                                        height: 768,
                                        content: "",
                                        rotate: 0,
                                        defaultFontName: "Arial",
                                        defaultColor: "",
                                        layout: [
                                            {
                                                type: "row",
                                                id: "4Oc7KTT8Cu",
                                                children: [
                                                    {
                                                        id: "sLTNq2znyp",
                                                        style: {
                                                            valign: "center",
                                                            align: "center",
                                                            justifyContent: "center",
                                                            margin: 5
                                                        },
                                                        alternateColor: null,
                                                        type: "subsection"
                                                    }
                                                ],
                                                style: {
                                                    backgroundColor: "transparent",
                                                    clipTop: 10,
                                                    clipRight: 10,
                                                    clipBottom: 10,
                                                    clipLeft: 10,
                                                    borderRadius: 10,
                                                    valign: "center",
                                                    align: "center",
                                                    justifyContent: "center"
                                                }
                                            }
                                        ],
                                        widgets: [
                                            {
                                                parent: "XOZ40vxcR2-sLTNq2znyp",
                                                children: [
                                                    {
                                                        id: "TtV8vNYjvh",
                                                        type: "reg_text",
                                                        subType: "out_text",
                                                        hookId: "",
                                                        compact: false,
                                                        iconPosition: "none",
                                                        text: "<p style=\"\"><span style=\"font-size: 30px\">Content here</span></p>",
                                                        step: 1,
                                                        currency: "USD",
                                                        locale: "en-US",
                                                        csv: {},
                                                        style: {
                                                            borderRadius: 0,
                                                            fontSize: "20px",
                                                            padding: 25
                                                        },
                                                        chartType: "",
                                                        imageUrl: "",
                                                        min: 0,
                                                        max: 100,
                                                        alternateColor: null
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                }
                            ],
                            id: "ZCCwfcGe41"
                        },
                        {
                            type: "row",
                            children: [
                                {
                                    id: "OzwQVVCz1m",
                                    style: {
                                        valign: "center",
                                        align: "center",
                                        justifyContent: "center",
                                        allTilesHeight: null,
                                        containerHeight: 115
                                    },
                                    alternateColor: null,
                                    type: "section",
                                    dragDropElement: {
                                        type: "dragdrop",
                                        id: "OzwQVVCz1m",
                                        left: 0,
                                        top: 0,
                                        width: 1366,
                                        height: 768,
                                        content: "",
                                        rotate: 0,
                                        defaultFontName: "Arial",
                                        defaultColor: "",
                                        layout: [
                                            {
                                                type: "row",
                                                id: "xANWII0B3Z",
                                                children: [
                                                    {
                                                        id: "kYpzDLVp9w",
                                                        style: {
                                                            valign: "center",
                                                            align: "right",
                                                            justifyContent: "",
                                                            margin: 5,
                                                            allTilesHeight: null
                                                        },
                                                        alternateColor: null,
                                                        type: "subsection"
                                                    }
                                                ],
                                                style: {
                                                    backgroundColor: "transparent",
                                                    clipTop: 10,
                                                    clipRight: 10,
                                                    clipBottom: 10,
                                                    clipLeft: 10,
                                                    borderRadius: 10,
                                                    valign: "center",
                                                    align: "center",
                                                    justifyContent: "center"
                                                }
                                            }
                                        ],
                                        widgets: [
                                            {
                                                parent: "OzwQVVCz1m-kYpzDLVp9w",
                                                children: [
                                                    {
                                                        id: "ieZLv9Sbe6",
                                                        type: "reg_text",
                                                        subType: "out_text",
                                                        hookId: "",
                                                        compact: false,
                                                        iconPosition: "none",
                                                        text: "<p style=\"\"><strong><span style=\"font-size: 30px\">Footer</span></strong></p>",
                                                        step: 1,
                                                        currency: "USD",
                                                        locale: "en-US",
                                                        csv: {},
                                                        style: {
                                                            borderRadius: 0,
                                                            fontSize: "20px",
                                                            padding: 25
                                                        },
                                                        chartType: "",
                                                        imageUrl: "",
                                                        min: 0,
                                                        max: 100,
                                                        alternateColor: null
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                }
                            ],
                            id: "EadHmtsJKk"
                        }
                    ]
                }
            },
            {
                type: "dragdrop",
                id: "iJ7MYSI7SP",
                left: 0,
                top: 0,
                width: 1366,
                height: 768,
                content: "",
                rotate: 0,
                defaultFontName: "Arial",
                defaultColor: "",
                layout: [
                    {
                        type: "row",
                        id: "ut_vld8yAk",
                        children: [
                            {
                                id: "iB6mgCX-En",
                                style: {
                                    valign: "center",
                                    align: "left",
                                    justifyContent: "",
                                    margin: 5
                                },
                                alternateColor: null,
                                type: "subsection"
                            }
                        ],
                        style: {
                            backgroundColor: "transparent",
                            clipTop: 10,
                            clipRight: 10,
                            clipBottom: 10,
                            clipLeft: 10,
                            borderRadius: 10,
                            valign: "center",
                            align: "center",
                            justifyContent: "center"
                        }
                    }
                ],
                widgets: [
                    {
                        parent: "iJ7MYSI7SP-iB6mgCX-En",
                        children: [
                            {
                                id: "BFaG2gkM1X",
                                type: "reg_text",
                                subType: "out_text",
                                hookId: "",
                                compact: false,
                                iconPosition: "none",
                                text: "<p style=\"\"><strong><span style=\"font-size: 30px\">Title</span></strong></p>",
                                step: 1,
                                currency: "USD",
                                locale: "en-US",
                                csv: {},
                                style: {
                                    borderRadius: 0,
                                    fontSize: "20px",
                                    padding: 25
                                },
                                chartType: "",
                                imageUrl: "",
                                min: 0,
                                max: 100,
                                alternateColor: null
                            }
                        ]
                    }
                ]
            },
            {
                type: "dragdrop",
                id: "XOZ40vxcR2",
                left: 0,
                top: 0,
                width: 1366,
                height: 768,
                content: "",
                rotate: 0,
                defaultFontName: "Arial",
                defaultColor: "",
                layout: [
                    {
                        type: "row",
                        id: "4Oc7KTT8Cu",
                        children: [
                            {
                                id: "sLTNq2znyp",
                                style: {
                                    valign: "center",
                                    align: "center",
                                    justifyContent: "center",
                                    margin: 5
                                },
                                alternateColor: null,
                                type: "subsection"
                            }
                        ],
                        style: {
                            backgroundColor: "transparent",
                            clipTop: 10,
                            clipRight: 10,
                            clipBottom: 10,
                            clipLeft: 10,
                            borderRadius: 10,
                            valign: "center",
                            align: "center",
                            justifyContent: "center"
                        }
                    }
                ],
                widgets: [
                    {
                        parent: "XOZ40vxcR2-sLTNq2znyp",
                        children: [
                            {
                                id: "TtV8vNYjvh",
                                type: "reg_text",
                                subType: "out_text",
                                hookId: "",
                                compact: false,
                                iconPosition: "none",
                                text: "<p style=\"\"><span style=\"font-size: 30px\">Content here</span></p>",
                                step: 1,
                                currency: "USD",
                                locale: "en-US",
                                csv: {},
                                style: {
                                    borderRadius: 0,
                                    fontSize: "20px",
                                    padding: 25
                                },
                                chartType: "",
                                imageUrl: "",
                                min: 0,
                                max: 100,
                                alternateColor: null
                            }
                        ]
                    }
                ]
            },
            {
                type: "dragdrop",
                id: "OzwQVVCz1m",
                left: 0,
                top: 0,
                width: 1366,
                height: 768,
                content: "",
                rotate: 0,
                defaultFontName: "Arial",
                defaultColor: "",
                layout: [
                    {
                        type: "row",
                        id: "xANWII0B3Z",
                        children: [
                            {
                                id: "kYpzDLVp9w",
                                style: {
                                    valign: "center",
                                    align: "right",
                                    justifyContent: "",
                                    margin: 5,
                                    allTilesHeight: null
                                },
                                alternateColor: null,
                                type: "subsection"
                            }
                        ],
                        style: {
                            backgroundColor: "transparent",
                            clipTop: 10,
                            clipRight: 10,
                            clipBottom: 10,
                            clipLeft: 10,
                            borderRadius: 10,
                            valign: "center",
                            align: "center",
                            justifyContent: "center"
                        }
                    }
                ],
                widgets: [
                    {
                        parent: "OzwQVVCz1m-kYpzDLVp9w",
                        children: [
                            {
                                id: "ieZLv9Sbe6",
                                type: "reg_text",
                                subType: "out_text",
                                hookId: "",
                                compact: false,
                                iconPosition: "none",
                                text: "<p style=\"\"><strong><span style=\"font-size: 30px\">Footer</span></strong></p>",
                                step: 1,
                                currency: "USD",
                                locale: "en-US",
                                csv: {},
                                style: {
                                    borderRadius: 0,
                                    fontSize: "20px",
                                    padding: 25
                                },
                                chartType: "",
                                imageUrl: "",
                                min: 0,
                                max: 100,
                                alternateColor: null
                            }
                        ]
                    }
                ]
            }
        ],
        background: {
            type: "solid",
            color: "#fff"
        }
    }
]